const MAX_BYTES = 32 * 1024 * 1024;
const unavailable = () => new Error('PRIVATE_PHOTO_UNAVAILABLE');
export function imageMetadata(bytes, variant) {
  const view = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
  let width, height, type;
  if (bytes.length >= 33 && [137,80,78,71,13,10,26,10].every((v,i) => bytes[i] === v)) {
    if (view.getUint32(8) !== 13 || String.fromCharCode(...bytes.slice(12,16)) !== 'IHDR') throw unavailable();
    width = view.getUint32(16); height = view.getUint32(20); type = 'image/png';
    const depth = bytes[24], color = bytes[25], depths = { 0:[1,2,4,8,16], 2:[8,16], 3:[1,2,4,8], 4:[8,16], 6:[8,16] };
    if (!depths[color] || !depths[color].includes(depth) || bytes[26] || bytes[27] || bytes[28] > 1) throw unavailable();
    const channels = { 0:1,2:3,3:1,4:2,6:4 }[color];
    const passes = bytes[28] ? [[0,0,8,8],[4,0,8,8],[0,4,4,8],[2,0,4,4],[0,2,2,4],[1,0,2,2],[0,1,1,2]] : [[0,0,1,1]];
    const inflated = passes.reduce((sum,[x,y,dx,dy]) => {
      const w = Math.max(0,Math.ceil((width-x)/dx)), h = Math.max(0,Math.ceil((height-y)/dy));
      return sum + (w && h ? h * (Math.ceil(w * channels * depth / 8) + 1) : 0);
    },0);
    if (inflated > MAX_BYTES) throw unavailable();
  } else {
    if (bytes.length < 12 || bytes[0] !== 255 || bytes[1] !== 216) throw unavailable();
    let offset = 2;
    while (offset < bytes.length) {
      if (bytes[offset++] !== 255) throw unavailable();
      while (bytes[offset] === 255) offset++;
      const marker = bytes[offset++];
      if (marker === 0xda || marker === 0xd9 || offset + 2 > bytes.length) throw unavailable();
      if (marker === 1) continue;
      const length = view.getUint16(offset);
      if (length < 2 || offset + length > bytes.length) throw unavailable();
      if ([0xc0,0xc1,0xc2].includes(marker)) {
        if (length < 8) throw unavailable();
        height = view.getUint16(offset + 3); width = view.getUint16(offset + 5); type = 'image/jpeg'; break;
      }
      offset += length;
    }
  }
  if (!width || !height || width > 16384 || height > 16384 ||
      (variant === 'watermarked' && (type !== 'image/jpeg' || width * height > 40000000)) ||
      (!['original', 'watermarked'].includes(variant) && (width !== Number(variant) || height !== Number(variant)))) throw unavailable();
  return { width, height, type };
}
export default async function inspectPrivatePhoto(blob, variant) {
  const buffer = typeof blob.arrayBuffer === 'function' ? await blob.arrayBuffer() : await new Promise((resolve,reject) => {
    const reader = new FileReader(); reader.onload = () => resolve(reader.result); reader.onerror = () => reject(unavailable()); reader.readAsArrayBuffer(blob);
  });
  const { type } = imageMetadata(new Uint8Array(buffer), variant);
  return blob.type === type ? blob : new Blob([blob], { type });
}
